// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"28bb096d","1364":"fb50bbbf","9599":"24b155d8"}[chunkId] + ".chunk.css";
};